import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PharmacySoftwareDataGrid from "../../components/PharmacySoftwareDataGrid";

/**
 * A platform admin manages every pharmacy's connection; a pharmacy administrator (roleId 2)
 * manages only their own branch. The API enforces that split, so the grid just reflects it.
 */
const PharmacySoftwarePage = () => {
  const currentUser = useSelector((state) => state.currentUser);
  const roleId = currentUser?.user?.roleId;

  useEffect(() => {
    document.title = "TransferMyRx::Pharmacy Software";
    const pageTitle = document.getElementById("page-title-text");
    if (pageTitle) {
      pageTitle.innerText = "Pharmacy Software";
    }
  }, []);

  if (roleId !== 1 && roleId !== 2) {
    return <>No Access</>;
  }

  return <PharmacySoftwareDataGrid isOwnBranchOnly={roleId === 2} />;
};

export default PharmacySoftwarePage;
